import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    clientName: {
      validations: []
    },
    category: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    reference: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    accountExtra3: {
      validations: []
    },
    accountExtra9: {
      validations: []
    },
    accountExtra10: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name (if applicable)',
            mapping: 'clientName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type *',
            options: [
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Business Event', value: 'Corporate' },
              { label: 'Social/Personal Event', value: 'Social' },
              { label: 'Tour', value: 'Tour Only' },
              { label: 'Group Tour w/Lunch or Dinner', value: 'Social' },
              { label: 'Kids/Scouting Event', value: 'Education' }
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'How did you hear about us? *',
            options: [
              { label: 'Internet Search', value: 'Internet Search' },
              { label: 'Facebook', value: 'Facebook' },
              { label: 'Instagram', value: 'Instagram' },
              { label: 'Pinterest', value: 'Pinterest' },
              { label: 'The Knot Website', value: 'The Knot Website' },
              { label: 'The Knot Magazine', value: 'The Knot Magazine' },
              { label: 'Metro Bride Website', value: 'Metro Bride Website' },
              { label: 'Metro Bride Magazine', value: 'Metro Bride Magazine' },
              { label: 'Wedding Wire', value: 'Wedding Wire' },
              { label: 'DBusiness', value: 'DBusiness' },
              { label: 'Circle Michigan', value: 'Circle Michigan' },
              { label: 'Previous Visit', value: 'Previous Visit' },
              { label: 'Word of Mouth', value: 'Word of Mouth' },
              { label: 'OU Affiliate', value: 'OU Affiliate' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Number of Guests',
            mapping: 'accountExtra9'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Please indicate your ideal event dates/time frame. Please provide any and all helpful information including if you have a specific date in mind, what year you are considering and/or if you prefer a specific day of the week. *',
            mapping: 'accountExtra10'
          }
        ]
      },
     {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Questions/Comments',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Meadow Brook Hall Contact Us Form',
    formId: '510',
    clientKey: 'BAAAEBFD-6073-47D0-8111-5B256C77CC1F',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://meadowbrookhall.org/contact-us/thank-you',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/meadowbrookhall/form_structure.js